/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../banking/common';
import '../common/currency';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "inflows": {
        "nested": {
          "InstantAccessProgram": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "owner": {
                "type": ".squareup.banking.Owner",
                "id": 2,
                "rule": "optional"
              },
              "platform": {
                "type": ".squareup.inflows.InstantAccessProgram.Platform",
                "id": 3,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.inflows.InstantAccessProgram.State",
                "id": 4,
                "rule": "optional"
              },
              "optInMechanism": {
                "type": ".squareup.inflows.InstantAccessProgram.OptInMechanism",
                "id": 5,
                "rule": "optional"
              },
              "isOptInCriteriaMet": {
                "type": "bool",
                "id": 6,
                "rule": "optional"
              },
              "isActivelyReceivingDeposits": {
                "type": "bool",
                "id": 7,
                "rule": "optional"
              },
              "isActivelyReceivingOrders": {
                "type": "bool",
                "id": 8,
                "rule": "optional"
              },
              "hasActiveDestinationBalance": {
                "type": "bool",
                "id": 9,
                "rule": "optional"
              },
              "instantAccessBalanceId": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "destinationBalanceId": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "withholdingRateBps": {
                "type": "int32",
                "id": 12,
                "rule": "optional"
              },
              "balanceSnapshotAmountMoney": {
                "type": ".squareup.common.Money",
                "id": 20,
                "rule": "optional"
              },
              "lastPayoutProcessedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 21,
                "rule": "optional"
              },
              "hasDeclinedByRiskOrderInPayoutCycle": {
                "type": "bool",
                "id": 19,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 13,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 14,
                "rule": "optional"
              },
              "version": {
                "type": "int64",
                "id": 16,
                "rule": "optional"
              }
            },
            "nested": {
              "State": {
                "values": {
                  "UNKNOWN_STATE_DO_NOT_USE": 0,
                  "INACTIVE": 1,
                  "ACTIVE": 2,
                  "OFFBOARDING": 3
                }
              },
              "Platform": {
                "values": {
                  "UNKNOWN_PLATFORM_DO_NOT_USE": 0,
                  "DOORDASH": 1,
                  "UBER_EATS": 2,
                  "GRUBHUB": 3
                }
              },
              "OptInMechanism": {
                "values": {
                  "UNKNOWN_OPT_IN_MECHANISM_DO_NOT_USE": 0,
                  "ALPHA_UNIT": 1,
                  "RST_PREM_PLUS_ONBOARDING": 2,
                  "TEST_ACCOUNT": 3,
                  "BETA_UNIT": 4,
                  "FIRST_PARTY_INTEGRATION": 5,
                  "PAID_PLAN_WAIVER": 6
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.inflows?.nested?.InstantAccessProgram && !$root.nested?.squareup?.nested?.inflows?.nested?.InstantAccessProgram?.nested?.State && !$root.nested?.squareup?.nested?.inflows?.nested?.InstantAccessProgram?.nested?.Platform && !$root.nested?.squareup?.nested?.inflows?.nested?.InstantAccessProgram?.nested?.OptInMechanism) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE InstantAccessProgram @ squareup/inflows/instant_access_program_model.proto at 12:1
 */
export const InstantAccessProgram = $root.lookupType('squareup.inflows.InstantAccessProgram');
fixType(InstantAccessProgram);
Builder.createAndAttachToType(InstantAccessProgram);
/**
 * SOURCE State @ squareup/inflows/instant_access_program_model.proto at 13:3
 */
InstantAccessProgram.State = $root.lookupEnum('squareup.inflows.InstantAccessProgram.State').values;
/**
 * SOURCE Platform @ squareup/inflows/instant_access_program_model.proto at 29:3
 */
InstantAccessProgram.Platform = $root.lookupEnum('squareup.inflows.InstantAccessProgram.Platform').values;
/**
 * SOURCE OptInMechanism @ squareup/inflows/instant_access_program_model.proto at 39:3
 */
InstantAccessProgram.OptInMechanism = $root.lookupEnum('squareup.inflows.InstantAccessProgram.OptInMechanism').values;